/* eslint-disable */

const registrationData = {
  user: "",
  age: "",
  gender: "",
  domicile: "",
  juz_number_memorized: "",
  juz_target_number: "",
  pilihan_infaq: 0,
  tahsin_experience: "",
  motivation: "",
  recording: null,
};

const state = {
  registrationData: registrationData,
};

const getters = {
  getRegistrationData: (state) => {
    return state.registrationData;
  },
  getHasProgramRegistered: (state) => {
    if (state.registrationData.user != "") {
      return true;
    }
    return false;
  },
};

const mutations = {
  setRegistrationData: (state, payload) => {
    state.registrationData = payload.registrationData;
  },
};

const actions = {
  RESETREGISTRATIONDATA: ({ commit }) => {
    commit("setRegistrationData", { registrationData: registrationData });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
